import React, { Component } from 'react';
import WebSocketInstance from 'services/webSocket/webSocket';
import NotificationManager from 'notificationManager/notificationManager';
import { ContainerNotification, ContainerNotificationModal } from 'components/styles/Common.styled';
import EventBus from 'utils/eventBus';
import { translate as t } from 'utils/i18n';
import environment from 'utils/environment';

class notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
      currentSlide: 0,
      notification: null,
      enterPose: 'enter',
      exitPose: 'exit',
      splitWords: 'words',
      timeout: null,
    };
    this.subscriptions = {};
    this.previousNotificationState = null;
    this.temporaryUpdateTimeout = null;
  }

  /**
   * Centralized method to update notification with optional temporary display
   * @param {string} message - The notification message
   * @param {boolean} isVisible - Whether the notification should be visible
   * @param {boolean} isTemporary - If true, reverts to previous state after 5 seconds
   */
  updateNotification = (message, isVisible, isTemporary = false) => {
    // Clear any existing temporary update timeout
    if (this.temporaryUpdateTimeout) {
      clearTimeout(this.temporaryUpdateTimeout);
      this.temporaryUpdateTimeout = null;
    }

    // Save current state as previous (unless this is a revert)
    if (!isTemporary) {
      this.previousNotificationState = {
        notification: this.state.notification,
        isVisible: this.state.isVisible,
      };
    }

    // Update to new state
    this.setState({
      notification: message,
      isVisible,
    });

    // If temporary, schedule revert to previous state
    if (isTemporary && this.previousNotificationState) {
      this.temporaryUpdateTimeout = setTimeout(() => {
        this.setState(this.previousNotificationState);
        this.temporaryUpdateTimeout = null;
        this.previousNotificationState = null;
      }, 5000);
    }
  };

  async componentDidMount() {
    this.subscriptions['ServerDown'] = EventBus.subscribe('ServerDown', () => {
      const msg = t('errors.serverDownNot');
      console.log(msg);
      this.updateNotification(msg, environment.isDemoMode() ? false : true);
    });
    this.subscriptions['CheckingServer'] = EventBus.subscribe('CheckingServer', () => {
      this.updateNotification('', false);
    });
    this.subscriptions['CacheUpdated'] = EventBus.subscribe('CacheUpdated', () => {
      if (!environment.isDemoMode()) {
        return;
      }
      return;
      const msg = t('Portal.cacheRefreshed') || 'Cache refreshed';
      this.updateNotification(msg, true, true);
    });
    this.establishWebSockectConnection(); // extablish the websocket connection
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    if (this.temporaryUpdateTimeout) {
      clearTimeout(this.temporaryUpdateTimeout);
    }
    for (let key in this.subscriptions) {
      this.subscriptions[key]['unsubscribe']();
    }
    this.setState = () => {
      return;
    };
  }

  establishWebSockectConnection() {
    this.waitForSocketConnection(() => {
      WebSocketInstance.addCallbacks(this.setMessages.bind(this)); // recieving notications
    });
  }
  waitForSocketConnection(callback) {
    if (WebSocketInstance.state() === 1) {
      console.log('Connection is made');
      callback();
      return;
    }
    clearTimeout(this.state.timeout);
    const timeout = setTimeout(() => {
      console.log('Wait for connection...');
      this.waitForSocketConnection(callback);
    }, 3000);

    this.setState({
      timeout,
    });
  }

  /**
   * Callback to display notification message
   * Called by NotificationManager with UI data
   */
  displayNotification = (notificationData) => {
    this.updateNotification(notificationData.notification, notificationData.isVisible);
    // Auto-hide notification after 20 seconds
    clearInterval(this.interval);
    this.interval = setInterval(() => this.setState({ isVisible: false }), 20000);
  };

  /**
   * Handle incoming notification message
   * Delegates all processing to NotificationManager
   */
  async setMessages(data) {
    // All notification processing handled centrally in NotificationManager
    // Pass callback for UI updates instead of component reference
    await NotificationManager.NotificationManager(data, this.displayNotification);
  }

  render() {
    let { isVisible, notification } = this.state;
    return (
      notification && (
        <ContainerNotification>
          {isVisible && [
            <ContainerNotificationModal>
              <div className='typewriter-container'>{notification}</div>
            </ContainerNotificationModal>,
          ]}
        </ContainerNotification>
      )
    );
  }
}

export default notification;
